import store from '@/store';
import axios from 'axios';

class Logger {
  constructor() {
    // Lade Einstellung aus localStorage oder nutze Default
    const stored = localStorage.getItem('app_logger_enabled');
    this.enabled = stored !== null
      ? stored === 'true'
      : process.env.NODE_ENV === 'development';
  }

  enable() {
    this.enabled = true;
    localStorage.setItem('app_logger_enabled', 'true');
  }

  disable() {
    this.enabled = false;
    localStorage.setItem('app_logger_enabled', 'false');
  }

  toggle() {
    this.enabled = !this.enabled;
    localStorage.setItem('app_logger_enabled', String(this.enabled));
  }

  info(...args) {
    if (store.getters['app/debugMode']) {
      console.info('[APP]', ...args);
    }
  }

  log(...args) {
    if (store.getters['app/debugMode']) {
      console.log('[APP]', ...args);
    }
  }

  error(...args) {
    if (args && args.length > 0 && args[1] instanceof axios.CanceledError)
      return; // Ignoriere Abbruch-Fehler

    console.error('[APP]', ...args);
  }

  warn(...args) {
    if (store.getters['app/debugMode']) {
      console.warn('[APP]', ...args);
    }
  }
}

export default new Logger();
